import { render, staticRenderFns } from "./FormRequirementCategory.vue?vue&type=template&id=633f4bfa"
import script from "./FormRequirementCategory.vue?vue&type=script&lang=js"
export * from "./FormRequirementCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports